export default [
  {
    path: '/satis/list',
    name: 'satis-list',
    component: () => import('@/views/satis/index.vue'),
    meta: {
      action: 'read',
      subject: 'satis',
      public: false,
      title: 'satis.Satışlar',
      yetki: { k: [2001802] },
    },
  },
]
